import React from 'react';

import GetCurrentProgressProvider from './components/context';
import GetCurrentProgressPageBody from './body';

export default function GetCurrentProgressScreen() {
  return (
    <GetCurrentProgressProvider>
      <GetCurrentProgressPageBody />
    </GetCurrentProgressProvider>
  );
}
